import { createApp } from 'vue'
import App from './App.vue'

const mountEl = document.querySelector('#darkmode')

if (mountEl) {
    const props = {}

    createApp(App, props).mount('#darkmode')
}
